import { Col, Modal, Row } from 'antd'
import React, { FC, useMemo } from 'react'
import ProSendEmailSMSComponent from 'features/property/components/ProSendEmailSMSComponent'
// import { TSendWidgetState } from 'types'
import { useProListing } from 'features/property/provider/ProListingProvider'
// import useAppControl from 'hooks/useAppControl'
import { useGetListingDetailsQuery } from 'features/property'
import { useGetPreconDetailQuery } from 'features/property/api/precon'
import PreCondoDetails from './PreCondoDetails'
import NonPreCondoDetails from './NonPreCondoDetails'

const PropertyDetailsModal: FC<{
 value?: string
 visible?: boolean
 onHide?: () => void
 isPreCon?: boolean
 //  item?: TPropertyListing
}> = ({
 visible,
 onHide,
 value,
 isPreCon,
 //  item
}) => {
 const { selectedPro, setSelectedPro } = useProListing()
 const { data: nonPreData, isLoading: nonPreLoading } =
  useGetListingDetailsQuery(
   {
    value,
    view_type: 'crm',
   },
   { skip: isPreCon },
  )

 const { data: preConData, isLoading: preConLoading } = useGetPreconDetailQuery(
  { slug: value ?? '' },
  { skip: !isPreCon },
 )

 const arUid = useMemo(
  () =>
   isPreCon ? preConData?.prop_list?.ar_uid : nonPreData?.prop_list?.ar_uid,
  [isPreCon, preConData, nonPreData],
 )

 const isAvailable = selectedPro.find((pro) => pro.ar_uid === arUid)
 //  const isSelected = useMemo(() => !!isAvailable, [isAvailable])

 const onChangeSelection = (): void => {
  if (isAvailable) {
   setSelectedPro?.(selectedPro?.filter((i) => i?.ar_uid !== arUid))
  } else {
   setSelectedPro?.([
    ...selectedPro,
    (isPreCon ? preConData?.prop_list : nonPreData?.prop_list) ?? {},
   ])
  }
 }

 return (
  <Modal
   //    title={null}
   centered
   width={1058}
   footer={null}
   onCancel={onHide}
   visible={visible}
   bodyStyle={{ background: '#f3f3f3' }}
   className="pro-details-modal"
   closeIcon={
    <span className="pro-list-and-modal-close-btn">
     <i className="fas fa-times" />
    </span>
   }
   title={
    <Row
     style={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
     }}
    >
     <Col style={{ justifySelf: 'flex-start' }}>Property Details</Col>
     {!(nonPreLoading || preConLoading) && (
      <Col style={{ marginRight: '40px' }}>
       <div>
        <ProSendEmailSMSComponent
         addListBtnType={!isAvailable ? 'add' : 'remove'}
         showSelectionBtn
         onChangeSelection={onChangeSelection}
         from="modal"
         proData={
          isPreCon
           ? {
              ...preConData?.prop_list,
              listing_type: 'preconstruction',
             }
           : nonPreData?.prop_list
         }
         onHide={onHide}
        />
       </div>
      </Col>
     )}
    </Row>
   }
  >
   {/* <NonPreCondoDetails value={value} /> */}
   {isPreCon ? (
    <PreCondoDetails
     slug={`${value}`}
     data={preConData}
     isLoading={preConLoading}
    />
   ) : (
    <NonPreCondoDetails
     value={value}
     data={nonPreData}
     isLoading={nonPreLoading}
    />
   )}
  </Modal>
 )
}

export default PropertyDetailsModal
